<template>
  <div>
    <main id="#main-content">
      <slot />
    </main>
  </div>
</template>

<script setup>
const locale = undefined

defineOptions({
  name: 'DefaultLayout',
})
useHead({
  htmlAttrs: {
    lang: locale || 'en',
  },
})
</script>

<style lang="css">
@reference "@/assets/css/main.css";
body {
  font-family: "IBM Plex Serif", serif;
  @apply bg-base-100 print:bg-white;
}
</style>
